/* IFFAH — theme scripts (vanilla, no dependencies) */
(function () {
  'use strict';

  var routes = (window.IFFAH && window.IFFAH.routes) || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = (window.IFFAH && window.IFFAH.moneyFormat) || '${{amount}}';
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, withCommas);
  }

  function lockScroll(on) {
    document.body.classList.toggle('is-locked', !!on);
  }

  /* ---------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    if (header.hasAttribute('data-sticky')) {
      var threshold = header.offsetTop + 120;
      var onScroll = function () {
        header.classList.toggle('is-stuck', window.scrollY > threshold);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var drawer = $('[data-menu-drawer]');
    if (drawer) {
      var open = function () { drawer.classList.add('is-open'); lockScroll(true); };
      var close = function () { drawer.classList.remove('is-open'); lockScroll(false); };
      $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }
  }

  /* ---------------------------------------------------------- search drawer */
  function initSearch() {
    var drawer = $('[data-search-drawer]');
    if (!drawer) return;
    var input = $('input[type="search"]', drawer);

    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.hidden = false;
        lockScroll(true);
        if (input) setTimeout(function () { input.focus(); }, 60);
      });
    });
    $$('[data-search-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { drawer.hidden = true; lockScroll(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { drawer.hidden = true; lockScroll(false); }
    });
  }

  /* ------------------------------------------------------------ announcement */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var i = 0;
    var show = function (n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    };
    var next = function () { show(i + 1); };
    var prev = function () { show(i - 1); };
    var timer = setInterval(next, parseInt(bar.dataset.speed || '5000', 10));
    var nextBtn = $('[data-announcement-next]', bar);
    var prevBtn = $('[data-announcement-prev]', bar);
    if (nextBtn) nextBtn.addEventListener('click', function () { clearInterval(timer); next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { clearInterval(timer); prev(); });
  }

  /* ------------------------------------------------------------------- cart */
  var Cart = {
    drawer: null,

    init: function () {
      Cart.drawer = $('[data-cart-drawer]');
      if (Cart.drawer) {
        $$('[data-cart-close]', Cart.drawer).forEach(function (b) {
          b.addEventListener('click', Cart.close);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') Cart.close();
        });
      }

      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (!Cart.drawer) return;
          e.preventDefault();
          Cart.open();
        });
      });

      document.addEventListener('click', function (e) {
        var remove = e.target.closest('[data-cart-remove]');
        if (remove) {
          e.preventDefault();
          Cart.change(remove.dataset.line, 0);
        }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty]');
        if (input) Cart.change(input.dataset.line, input.value);
      });

      var note = $('[data-cart-note]');
      if (note) {
        var t;
        note.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            fetch(routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: note.value })
            });
          }, 500);
        });
      }
    },

    open: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.add('is-open');
      lockScroll(true);
    },

    close: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.remove('is-open');
      lockScroll(false);
    },

    add: function (formData, button) {
      var original = button ? button.innerHTML : '';
      if (button) { button.setAttribute('aria-disabled', 'true'); button.innerHTML = '…'; }

      return fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          return Cart.refresh();
        })
        .then(function () {
          if (window.IFFAH.cartType === 'drawer') Cart.open();
          else window.location.href = routes.cart_url;
        })
        .catch(function (err) {
          if (button) {
            button.innerHTML = err.message || 'Unavailable';
            setTimeout(function () { button.innerHTML = original; }, 2200);
          }
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            if (button.innerHTML === '…') button.innerHTML = original;
          }
        });
    },

    change: function (line, quantity) {
      return fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: parseInt(quantity, 10) })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
            return;
          }
          return Cart.refresh();
        });
    },

    refresh: function () {
      return fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-inner]');
          var current = $('[data-cart-drawer-inner]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;

          var freshCount = doc.querySelector('[data-cart-count]');
          $$('[data-cart-count]').forEach(function (el) {
            if (!freshCount) return;
            el.textContent = freshCount.textContent;
            el.hidden = freshCount.hidden;
          });
        });
    }
  };

  /* ------------------------------------------------------------ add to cart */
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      Cart.add(new FormData(form), button);
    });
  }

  /* -------------------------------------------------------- quantity widget */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap.querySelector('input');
      var step = btn.dataset.qtyChange === 'up' ? 1 : -1;
      var min = parseInt(input.min || '1', 10);
      var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------ product page */
  function initProduct() {
    var root = $('[data-product-root]');
    if (!root) return;

    var variantsEl = $('[data-variants]', root);
    if (!variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', root);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-product-price]', root);
    var submit = form ? form.querySelector('[type="submit"]') : null;
    var stock = $('[data-product-stock]', root);
    var sku = $('[data-product-sku]', root);

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (i) { return i.value; });
    }

    function findVariant(options) {
      return variants.filter(function (v) {
        return options.every(function (opt, i) { return v.options[i] === opt; });
      })[0];
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var target = $('[data-media-id="' + variant.featured_media.id + '"]', root);
      if (target) showMedia(variant.featured_media.id);
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);

      $$('[data-option-display]', root).forEach(function (el) {
        var idx = parseInt(el.dataset.optionDisplay, 10);
        if (options[idx]) el.textContent = options[idx];
      });

      if (!variant) {
        if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = window.IFFAH.strings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '<span class="' + (variant.compare_at_price > variant.price ? 'price__sale' : '') + '">' +
          formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      if (sku) sku.textContent = variant.sku || '';

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('aria-disabled');
          submit.textContent = window.IFFAH.strings.addToCart;
        } else {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = window.IFFAH.strings.soldOut;
        }
      }

      if (stock) {
        stock.className = 'product__stock' + (variant.available ? '' : ' product__stock--out');
        stock.innerHTML = '<i></i>' + (variant.available ? stock.dataset.inStock : stock.dataset.outStock);
      }

      updateMedia(variant);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', root).forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();

    /* gallery */
    function showMedia(id) {
      $$('[data-media-id]', root).forEach(function (m) {
        m.classList.toggle('is-active', m.dataset.mediaId === String(id));
      });
      $$('[data-thumb-id]', root).forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumbId === String(id));
      });
    }

    $$('[data-thumb-id]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumbId); });
    });
  }

  /* ------------------------------------------------------------- carousels */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (carousel) {
      var track = $('[data-carousel-track]', carousel);
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var index = 0;
      var dotsWrap = $('[data-carousel-dots]', carousel);

      function perView() {
        var w = window.innerWidth;
        if (w <= 749) return 1;
        if (w <= 900) return 2;
        return parseInt(carousel.dataset.perView || '3', 10);
      }

      function maxIndex() { return Math.max(0, slides.length - perView()); }

      function go(n) {
        index = Math.min(Math.max(n, 0), maxIndex());
        track.style.transform = 'translateX(-' + (index * (100 / perView())) + '%)';
        if (dotsWrap) {
          $$('button', dotsWrap).forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        }
      }

      slides.forEach(function (s) { s.style.flex = '0 0 ' + (100 / perView()) + '%'; });

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i <= maxIndex(); i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
            b.addEventListener('click', function () { go(n); });
            dotsWrap.appendChild(b);
          })(i);
        }
      }

      var nextBtn = $('[data-carousel-next]', carousel);
      var prevBtn = $('[data-carousel-prev]', carousel);
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          slides.forEach(function (s) { s.style.flex = '0 0 ' + (100 / perView()) + '%'; });
          go(0);
        }, 180);
      });

      go(0);
    });
  }

  /* ---------------------------------------------------------------- facets */
  function initFacets() {
    var panel = $('[data-facets]');
    if (!panel) return;
    $$('[data-facets-open]').forEach(function (b) {
      b.addEventListener('click', function () { panel.classList.add('is-open'); lockScroll(true); });
    });
    $$('[data-facets-close]').forEach(function (b) {
      b.addEventListener('click', function () { panel.classList.remove('is-open'); lockScroll(false); });
    });

    $$('[data-facet-input]', panel).forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });

    var sort = $('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* -------------------------------------------------------------- countdown */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      var fields = {
        days: $('[data-cd-days]', el),
        hours: $('[data-cd-hours]', el),
        minutes: $('[data-cd-minutes]', el),
        seconds: $('[data-cd-seconds]', el)
      };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (fields.days) fields.days.textContent = pad(d);
        if (fields.hours) fields.hours.textContent = pad(h);
        if (fields.minutes) fields.minutes.textContent = pad(m);
        if (fields.seconds) fields.seconds.textContent = pad(s);
      };
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ----------------------------------------------------------------- reveal */
  function initReveal() {
    if (!document.body.classList.contains('reveal-on')) return;
    if (!('IntersectionObserver' in window)) {
      $$('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------- boot */
  function boot() {
    initHeader();
    initSearch();
    initAnnouncement();
    Cart.init();
    initProductForms();
    initQuantity();
    initProduct();
    initCarousels();
    initFacets();
    initCountdown();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
